export default __webpack_public_path__ + "static/media/hero-slide2-bg.987f4730.webp";